import { getSelectors } from '@repo/core'
import { productsByTypeDataSelectorConfig } from './productsByTypeData'

export const productsByTypeDataSelector = getSelectors({
  getRootPath: productsByTypeDataSelectorConfig.productsByTypeDataSelector.getRootPath,
})
